import { addCallAppError, addCallAppSuccess, reportReConfig } from '@mtfe/sweet-report';
import { isInWeixin, isMiniProgram } from './container';
import initWxConfig from './initWxSdk';

const deepLinkInWeiXin = ({ type, dpUrl, success, fail }) => {
    const loaderSuccessCb = (wx = window.wx) => {
        if (!wx) {
            console.error('wx is undefined!');
            fail && fail();
            return;
        }

        wx.ready(() => {
            const appMap = {
                meituan: {
                    id: 'wxc72f01f43da0083b',
                    native: 'imeituan://www.meituan.com',
                },
                dianping: {
                    id: 'wx8e251222d6836a60',
                    native: 'dianping://',
                },
                ping51: {
                    id: 'wx1613983303fce900',
                    native: 'dianping://',
                },
                waimai: {
                    id: 'wx9f6523d23a33a5b3',
                    native: 'meituanwaimai://waimai.meituan.com',
                },
            };

            if (!appMap[type]) {
                console.error('Invalid type:', type);
                fail && fail(); // 添加fail回调，以便处理无效类型错误
                return;
            }

            const launchConfig = {
                appID: appMap[type].id, // 第三方应用在微信开放平台的 AppID
                schemeUrl: dpUrl, // 应用的 Scheme URL
                extInfo: '', // （可选） 其他扩展信息
            };

            wx.invoke('launchApplication', launchConfig, function (res) {
                if (res.err_msg === 'launchApplication:fail') {
                    fail && fail();
                } else if (res.err_msg === 'launchApplication:ok') {
                    success && success();
                } else {
                    // 版本过低或者其他情况导致的唤起失败
                    fail && fail();
                }
            });
        });

        wx.error(function (res) {
            fail && fail();
            console.error('微信JSSDK配置错误:', res);
        });
    };
    initWxConfig(loaderSuccessCb, { account: type });
};

function detectAppJump(options = {}) {
    const { lp, deepLinkFail, deepLinkSuccess } = options;
    let jumped = false;

    // 如果500ms后执行则认为跳转失败
    const timer = setTimeout(() => {
        if (!jumped) {
            // 优化：仅在未跳转时调用错误处理函数
            addCallAppError('非微信 deepLink 跳转失败');
            deepLinkFail && deepLinkFail();

            if (lp && lp.indexOf('http') === 0) {
                // 优化：在跳转前可以考虑增加用户提示或加载动画
                setTimeout(() => {
                    window.location.href = lp;
                }, 500);
            } else {
                // 如果没有跳转走，改回配置
                reportReConfig({
                    error: {
                        sample: 1,
                        delay: 1000,
                    },
                    metric: {
                        sample: 1,
                        delay: 1500,
                    },
                });
            }
            removeEventListeners();
        }
    }, 500);

    function clearHandler() {
        if (!jumped) {
            clearTimeout(timer);
            jumped = true;
            removeEventListeners();
            addCallAppSuccess();
            deepLinkSuccess && deepLinkSuccess();
        }
    }

    function removeEventListeners() {
        document.removeEventListener('visibilitychange', clearHandler);
        window.removeEventListener('blur', clearHandler);
    }

    document.addEventListener('visibilitychange', clearHandler);
    window.addEventListener('blur', clearHandler);
}

/**
 * 失败的回调延迟500ms 执行，主要目的在于失败的自定义上报会在执行后300ms 上报。
 * @returns
 */
const createDeepLink = () => {
    return {
        gotoDp: (dp, lp, before, cbOptions = {}) => {
            //warn 受跳转影响，这里的回调函数执行并不保证，尤其对于一些异步操作尤其需要注意
            const { deepLinkSuccess, deepLinkFail } = cbOptions;

            if (before) {
                before();
            }

            // 更改上报的配置，以在跳转之前完成上报，正常metric延迟为1500ms
            reportReConfig({
                error: {
                    sample: 1,
                    delay: 300,
                },
                metric: {
                    sample: 1,
                    delay: 300,
                },
            });

            if (isInWeixin) {
                if (isMiniProgram) {
                    if (lp && lp.indexOf('http') === 0) {
                        addCallAppSuccess();
                        deepLinkSuccess && deepLinkSuccess();
                        setTimeout(() => {
                            window.location.href = lp;
                        }, 500);
                    } else {
                        addCallAppError('小程序跳转缺乏 lp 参数');
                        deepLinkFail && deepLinkFail();
                    }
                } else {
                    // 小程序走url跳转，不能用SDK，否则某些机型重复刷新
                    let type = 'meituan';

                    // 点评的 DP 链接
                    if (dp.indexOf('dianping://') === 0) {
                        if (window.location.href.indexOf('dianping.com') > -1) {
                            // 点评域名
                            type = 'dianping';
                        } else if (window.location.href.indexOf('51ping.com') > -1) {
                            // 51ping域名
                            type = 'ping51';
                        }
                    }

                    deepLinkInWeiXin({
                        type, // 必填，指定唤起App的类型，默认支持类型：meituan | dianping | ping51
                        dpUrl: dp, // 必填，完整的唤起链接
                        success: () => {
                            // 这个 success 单独指弹出了跳转的对话框，并不是实际跳转走了
                            addCallAppSuccess();
                            deepLinkSuccess && deepLinkSuccess();
                        },
                        fail: () => {
                            addCallAppError('wx deepLink 跳转失败');
                            deepLinkFail && deepLinkFail();
                            if (lp && lp.indexOf('http') === 0) {
                                setTimeout(() => {
                                    window.location.href = lp;
                                }, 500);
                            } else {
                                // 如果没有跳转走，改回配置
                                reportReConfig({
                                    error: {
                                        sample: 1,
                                        delay: 1000,
                                    },
                                    metric: {
                                        sample: 1,
                                        delay: 1500,
                                    },
                                });
                            }
                        },
                    });
                }
            } else {
                detectAppJump({ lp, deepLinkFail, deepLinkSuccess });
                setTimeout(
                    () => {
                        window.location.href = dp;
                    },
                    !!before ? 100 : 0,
                );
            }
        },
    };
};

export default createDeepLink;
